// © 2026 AttainIP Engineering

export type ServiceStatus = 'up' | 'down' | 'unknown';

/**
 * Status pill for the Dashboard Service Health widget.
 *
 * Pass `status` for the tri-state Prometheus-driven rendering
 * (up/down/unknown). The legacy `healthy: boolean` prop is also
 * supported for callers that still use the old /admin/health
 * fan-out shape — true → up, false → down.
 */
export function StatusBadge({
  status,
  healthy,
}: {
  status?: ServiceStatus;
  healthy?: boolean;
}) {
  const resolved: ServiceStatus =
    status ?? (healthy === undefined ? 'unknown' : healthy ? 'up' : 'down');

  const style =
    resolved === 'up'
      ? { pill: 'bg-green-100 text-green-800', dot: 'bg-green-500', label: 'Up' }
      : resolved === 'down'
      ? { pill: 'bg-red-100 text-red-800', dot: 'bg-red-500', label: 'Down' }
      : { pill: 'bg-gray-100 text-gray-600', dot: 'bg-gray-400', label: 'Unknown' };

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium ${style.pill}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${style.dot}`} />
      {style.label}
    </span>
  );
}
